export const catalogEnvironmentError = 'Create Catalog and Copy Catalog are only available on stage and barako.';

export const isCatalogEnvironment = (deployment: string) => deployment === 'stage' || deployment === 'barako';
